import { store } from "../store";
import { authChange } from "../store/Auth";
import { HttpHandler } from "./http-handler";
import { HttpRequest as BaseHttpRequest } from "./http-request";
import CurrencyFormat from "currency-formatter";

const percent = /^(100(\.0{0,2}?)?$|([1-9]|[1-9][0-9])(\.\d{1,2})?)$/gm;
const currencyRegex = /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/;
const dayRegex = /^[0-9\b]{1,3}$/gm;
const registerNumber = /^[А-Яа-я|Үү|Өө|Ёё]{2}[0-9]{8}$/;

const numberRegex = /[0-9]/gm;
const bankAccountRegex = /^\+?\d{10,15}$/;
const number = /^\b([1-9]|[12345678][0-9]|9[00])\b/;
const latin = /^[A-Za-z||Aa||Zz||_|0-9|| |-]+$/;
const mn = /^[А-Яа-я||Үү||Өө||0-9]+$/;

export class HttpRequest extends BaseHttpRequest {
  store = store;

  errorHandler = (statusCode: number, error: HttpHandler): HttpHandler => {
    if (statusCode === 401) {
      store.dispatch(authChange());
    }

    throw error;
  };
}

const tugrug = (value: number) =>
  CurrencyFormat.format(value, {
    code: "MNT",
    format: "%v %s",
    thousand: "'",
    decimal: ".",
  });

export { percent, currencyRegex, dayRegex, registerNumber, numberRegex, bankAccountRegex, tugrug, number, latin, mn };
